import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth0 } from '@auth0/auth0-react';
import { useApiClient } from '@client/hooks/useApiClient';
import { callApi } from '@client/utils/apiUtils';
import React, { useContext, useEffect, useState } from 'react';
const UserContext = React.createContext(undefined);
export const UserProvider = (props) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const apiClient = useApiClient();
    const { isAuthenticated } = useAuth0();
    const loadUser = async () => {
        setLoading(true);
        setError(null);
        const result = await callApi(apiClient.me.getMe());
        if (result.error !== null) {
            setError(result.error);
            setUser(null);
        }
        else {
            setUser(result.data);
        }
        setLoading(false);
    };
    useEffect(() => {
        if (isAuthenticated) {
            loadUser();
        }
        else {
            setUser(null);
        }
    }, [isAuthenticated]);
    return (_jsx(UserContext.Provider, { value: {
            user,
            isLoading: loading,
            error,
            refresh: loadUser,
        }, children: props.children }));
};
export const useUserInfo = () => {
    const ctx = useContext(UserContext);
    if (!ctx) {
        throw new Error('useUserInfo must be used within a UserProvider');
    }
    return ctx;
};
